import styled from 'styled-components';
import { space, color, layout, flexbox, shadow, position, border } from 'styled-system';

const BaseContainer = styled.div`
    ${color}
    ${space}
    ${layout}
    ${flexbox}
    ${shadow}
    ${position}
    ${border}
`;

export default BaseContainer;
